<div class="white-bg">
  <breadcrumbs>
    <breadcrumb route="/" label="Dashboard"></breadcrumb>
    <breadcrumb route="/measurement-points" label="Measurement Points"></breadcrumb>
    <breadcrumb [currentRoute]="true" [label]="componentTypePlusName"></breadcrumb>
  </breadcrumbs>
</div>

<div class="center" *ngIf="compartViewModel == null">
  <mat-spinner></mat-spinner>
</div>


<div class="panel" *ngIf="compartViewModel != null" [@enterAnimation]>
  <div class="panel__content flex flex--align-center">
    <!-- <div class="overall-eval-container">
              <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
              <div class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.PercentWorn | wornPercentageToEval }}">
                  {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
              </div>
          </div> -->
    <div class="column-container flex-grow">
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ Translate('Componet Type') }}
          </span>
          <span class="text-block__important">
            {{compartViewModel.CompartType}}
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{ Translate('Component') }}
          </span>
          <span class="text-block__important">
            {{compartViewModel.CompartName}}
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ Translate('Make') }}
          </span>
          <span class="text-block__important">
            {{compartViewModel.Make}}
          </span>
        </div>
        <!-- <div class="text-block">
          <span class="text-block__label">
            {{ Translate('Models') }}
          </span>
          <span class="text-block__important">
            {{compartViewModel.Models}}
          </span>
        </div> -->
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            <!-- {{ Translate('Last Inspection Date') }} -->
          </span>
          <span class="text-block__important">
            <div style="margin-left: 30px">
              <span>Inches</span>
              <ui-switch [(ngModel)]="UOM" (click)="ConvertUOM($event)"></ui-switch>
              <span>Mm</span>
          </div>
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            <!-- {{ Translate('Next Inspection Date') }} -->
          </span>
          <span class="text-block__important">
            <!-- {{ equipmentDetails.NextInspectionDate }} -->
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            <!-- {{ Translate('Meter Reading (SMU)') }} -->
          </span>
          <span class="text-block__important">
            <!-- {{equipmentDetails.Smu}} -->
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            <!-- {{ Translate('Life to Date (LTD)') }} -->
          </span>
          <span class="text-block__important">
            <!-- {{equipmentDetails.Ltd}} -->
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            <!-- {{ Translate('Make') }} -->
          </span>
          <span class="text-block__important">
            <!-- {{equipmentDetails.Make}} -->
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            <!-- {{ Translate('Model') }} -->
          </span>
          <span class="text-block__important">
            <!-- {{equipmentDetails.Model}} -->
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">

            <a class="button button--primary" style="margin-bottom: 16px;" (click) = "addMeasurementPoints(compartViewModel)">
              <i class="material-icons button__icon">add</i>
              <span class="button__text">{{Translate('Add Measurement Points')}}</span>
            </a>
            <!-- {{ Translate('Family') }} -->
          </span>
          <span class="text-block__important">
            <!-- {{equipmentDetails.Family}} -->
          </span>
        </div>
      </div>
    </div>
  </div>
  
</div>


<div class="panel__content no-padding">
  <div>
    <table class="table table--striped table--full-width">
      <thead>
        <tr>
          <!-- <th style="width: 20px">More</th> -->
          <th style="width: 50px">Image</th>
          <th>Type</th>
          <th>Make</th>
          <th>Model</th>
          <th>Component Type</th>
          <th>Component</th>
          <th *ngIf="compartViewModel.CompartType=='TrackFrame'">Sub-Component</th>
          <th>Measurement Point</th>
          <th>Obs.Type/Tool</th>
          <th>0% Worn Dim.</th>
          <th>100% Worn Dim.</th>
          <th>Tolerance</th>
          <th></th>
          <th *ngIf="compartViewModel.CompartType!='TrackFrame'"></th>

          <th>Obs.Pt Order</th>
          <th class="align-right">Status <i class="material-icons" [matTooltip]="'Points that are Enabled will be shown for Inspection'">info</i></th>


          <!-- <th  *ngIf="compartViewModel.CompartType=='TrackFrame'">Component</th>
         
          <th *ngIf="compartViewModel.CompartType!='TrackFrame'">Method</th>
          <th>0% Worn Dim.</th>
          <th>100% Worn Dim.</th>
          <th></th>
          <th class="align-right">Status <i class="material-icons" [matTooltip]="'Points that are Enabled will be shown for Inspection'">info</i></th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let point of measurementPoints; let i = index" class="table-row-style"  click-stop-propagation  >
          <!-- <td (click)="editMeasurementPoints(point)">
            <div>
              <div mat-icon-button >
                <i class="material-icons" style="cursor:pointer ;" title="Edit Observation Point Limits">more_vert</i>
              </div>
            </div>
          </td> -->
          <td >
            <img class="measurement-image"  src="/Api/Application/getMeasurementPointsThumbnail/?measurementPonitsId={{point.MeasurementPonitId}}"  />
          </td>
          <td *ngIf="compartViewModel.CompartType =='TrackFrame'">WSRE</td>
          <td *ngIf="compartViewModel.CompartType !='TrackFrame'">RSH/Hydraulic</td>
          <td>{{compartViewModel.Make}}</td>
          <td *ngIf="compartViewModel.CompartType !='TrackFrame'">{{compartViewModel.Models}}</td>
          <td *ngIf="compartViewModel.CompartType =='TrackFrame'">{{point.ModelName}}</td>

          <td>{{compartViewModel.CompartType}}</td>
          <td>{{compartViewModel.CompartName}}</td>
          <td *ngIf="compartViewModel.CompartType =='TrackFrame'">{{point.WSRETypeName}}</td>
          <td style="cursor:pointer ;" title="Edit Observation Point Limits">{{point.Name}}</td>
         
          <td>{{point.ToolName}}</td>
          <td *ngIf="compartViewModel.CompartType != 'TrackFrame'">{{point.StartingDim}}</td>
          <td *ngIf="compartViewModel.CompartType != 'TrackFrame'">{{point.EndingDim}}</td>

          <td *ngIf="compartViewModel.CompartType == 'TrackFrame'">{{point.worn_0_prec}}</td>
          <td *ngIf="compartViewModel.CompartType == 'TrackFrame'">{{point.worn_100_prec_Dim}}</td>
          <td>{{point.Tolerance}}</td>

          <td title="Update Observation Point details">
            <button mat-raised-button color="warn" style="z-index: 99;" (click)="UpdateMP(point,compartViewModel)">
                  <span class="button__text">Update Details</span>
              </button>
          </td>

          <td  *ngIf="compartViewModel.CompartType != 'TrackFrame'" title="Update Limits for Measurement Point">
            <button mat-raised-button color="warn" style="z-index: 99;" (click)="editMeasurementPoints(point)">
                  <span class="button__text">Update Limits</span>
              </button>
          </td>

          <td>
            <div style="display: flex;">
              <mat-icon style="vertical-align: middle; cursor: pointer;" (click)="OrderUP(point.Order,point.Id)" 
              [class.button-hide]="isFirstComponentInList(point, i)">arrow_upward</mat-icon>                
              <mat-icon style="vertical-align: middle; cursor: pointer;" (click)="OrderDown(point.Order,point.Id)"
              [class.button-hide]="isLastComponentInList(point, i)">arrow_downward</mat-icon>
            </div>
          </td>
          <td class="align-right"  click-stop-propagation  [matMenuTriggerFor]="operation"  (click)="$event.stopPropagation();">
            <div>
                <div class="editable-text" style="color:green"  *ngIf="!point.isDisabled"> Enabled</div>
                <div class="editable-text"  style="color:red"  *ngIf="point.isDisabled" > Disabled</div>
                <mat-menu #operation="matMenu">
                  <button mat-menu-item (click) = "changeMeasurementPointStatus(true, point)" >
                    <mat-icon>block</mat-icon>
                    <span>Disable</span>
                  </button>
                  <button mat-menu-item  (click) = "changeMeasurementPointStatus(false,point)" >
                    <mat-icon>lock_open</mat-icon>
                    <span>Enable</span>
                  </button>
                </mat-menu>
              </div>

        </td>

          <!-- <td *ngIf="compartViewModel.CompartType =='TrackFrame'">{{point.WSRETypeName}}</td>
          <td *ngIf="compartViewModel.CompartType =='TrackFrame'">{{point.ModelName}}</td>

          <td *ngIf="compartViewModel.CompartType != 'TrackFrame'">{{point.CalcMethod}}</td>
          <td *ngIf="compartViewModel.CompartType != 'TrackFrame'">{{point.StartingDim}}</td>

          <td *ngIf="compartViewModel.CompartType != 'TrackFrame'">{{point.EndingDim}}</td>
          <td *ngIf="compartViewModel.CompartType == 'TrackFrame'">{{point.worn_0_prec}}</td>


          <td *ngIf="compartViewModel.CompartType == 'TrackFrame'">{{point.worn_100_prec_Dim}}</td>

        
          <td title="Update Observation Point details">
            <button mat-raised-button color="warn" style="z-index: 99;" (click)="UpdateMP(point)">

                 
                  <span class="button__text">Update</span>
              </button>
          </td>
          <td (click)="editMeasurementPoints(point)" class="align-right"  click-stop-propagation  [matMenuTriggerFor]="operation"  (click)="$event.stopPropagation();">
              <div>
                  <div class="editable-text" style="color:green"  *ngIf="!point.isDisabled"> Enable</div>
                  <div class="editable-text"  style="color:red"  *ngIf="point.isDisabled" > Disable</div>
                  <mat-menu #operation="matMenu">
                    <button mat-menu-item (click) = "changeMeasurementPointStatus(true, point)" >
                      <mat-icon>block</mat-icon>
                      <span>Disable</span>
                    </button>
                    <button mat-menu-item  (click) = "changeMeasurementPointStatus(false,point)" >
                      <mat-icon>lock_open</mat-icon>
                      <span>Enable</span>
                    </button>
                  </mat-menu>
                </div>

          </td> -->
        </tr>

      </tbody>
    </table>
  </div>
</div>
